import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Telegram from './Index.vue';
import Groups from './Groups.vue';

export default {
  routes: [{
    path: frontendURL('accounts/:accountId/settings/telegram'),
    component: SettingsWrapper,
    props: { keepAlive: false },
    meta: { permissions: ['administrator'] },
    children: [{ path: '', name: 'telegram_settings', component: Telegram,
      meta: { permissions: ['administrator'] } }],
  }, {
    path: frontendURL('accounts/:accountId/settings/telegram-groups'),
    component: SettingsWrapper,
    props: { keepAlive: false },
    meta: { permissions: ['administrator'] },
    children: [{ path: '', name: 'telegram_groups_settings', component: Groups,
      meta: { permissions: ['administrator'] } }],
  }],
};
